/**
 * Season 1 world lore — the participant-safe half of the season bible
 * (cast bios and day-1 setups only; never act summaries or anything derived
 * from the event schedule).
 */

export interface TokenLore {
  /** Display token, e.g. "DARK". */
  token: string;
  company: string;
  epithet?: string;
  motto: string;
  /** Two-sentence character sketch. */
  character: string;
  /** The situation walking into day 1 — the pilot-episode hook. */
  day1: string;
}

export const TOKEN_LORE: Record<string, TokenLore> = {
  VAN: {
    token: "VAN",
    company: "Vanillin Standard Consolidated",
    epithet: "the Standard",
    motto: "Plain. Reliable. Everywhere.",
    character:
      "Synthetic vanillin at continental scale, run like a central bank by Chair Madeleine Bourbon and the Flavor Governors. Every pair on Sugar Rush quotes against it — nobody loves it, everybody accepts it.",
    day1:
      "Nothing. That's the brand. VAN's entire pre-season drama is the absence of drama.",
  },
  DARK: {
    token: "DARK",
    company: "Theobroma Noir Holdings",
    epithet: "the House of Noir",
    motto: "Provenance is the product.",
    character:
      "The chocolate-chip stock: premium single-origin dark chocolate, flagship 88% Midnight Reserve, origin-traced bean-to-bar on Noir's proof-of-provenance ledger. Patrician, unhurried, chaired by Theodore “Theo” Broma III, who signs letters “yours in cacao.”",
    day1:
      "Cocoa input costs are grinding up, and there's a low hum of consumer-lab chatter about heavy metals in premium dark chocolate that Noir's IR team has so far answered with wine pairings.",
  },
  STACH: {
    token: "STACH",
    company: "Kern & Shell Pistachio Co.",
    motto: "Tough nut. Good crack.",
    character:
      "Vertically integrated pistachio — orchards, cracking plants, kernels, and shells pressed into fuel pellets. The steadiest hands in the aisle, cursed to attract the most theatrical enemies; perennially accused of being a shell company (it is, in fact, a company with an enormous number of shells).",
    day1:
      "Freezer Burn Capital has been circling all summer. Everyone on Parlor Street expects the report at the opening bell.",
  },
  BREW: {
    token: "BREW",
    company: "Brrrew, Inc.",
    motto: "Ship on vibes and physics.",
    character:
      "Caffeinated frozen desserts: nitro cold-brew soft serve and the about-to-launch Overclock line of espresso-injected pints. Founded and ruled by Preston “Press” Martini, who says “supply go brrr” unironically. Half of Parlor Street thinks BREW is the future of dessert; the other half thinks it's decaf.",
    day1:
      "Overclock preorders open tonight-ish. The cap table is rumored to be mostly vibes and convertible notes, and Press is said to have pledged a large slice of his stake against loans for his tunnel-boring hobby. The words “margarine call” have been whispered.",
  },
  UBE: {
    token: "UBE",
    company: "Ubérie Purple Group",
    epithet: "the Purple Chain",
    motto: "You'll know when we tell you.",
    character:
      "Trendy fast-casual soft-serve, ~400 stores; the color does the marketing. Founded by the beloved, semi-retired Auntie Ube; run day-to-day by CEO Vi Taro. Long silences, then thunder: UBE says nothing for weeks and then re-rates the entire thesis in an afternoon.",
    day1:
      "Comps have been a black box for two quarters, franchisees are grumbling about discounts, and there are overseas rumors nobody can pin down.",
  },
  RASP: {
    token: "RASP",
    company: "Razzle Dash, Inc.",
    motto: "Cold to your door.",
    character:
      "The delivery app orbiting everyone else — couriers in raspberry-pink vests, the Pink Fleet. Founded by Bram Bramble, who once said “we lose a little on every scoop and make it up in volume” and has been asked about it at every conference since. Perpetually one deal away from profitability.",
    day1:
      "Courier pay tension is simmering, cash burn is racing freezer burn, and the whole company's fate is levered to other people's news — the UBÉRIE delivery exclusive is the crown jewel, and everyone knows it.",
  },
};
